import React from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Row, Col, Layout, Input, Typography, Button } from 'antd';
import { ApiSearchCss, SearchBarCss } from './ApiServiceList.style';

const { Header } = Layout;
const { Search } = Input;

const prefix = (
  <SearchOutlined
    style={{
      fontSize: 16,
      color: '#C2C2C2',
    }}
  />
);

const searchButton = (
  <Button type="primary" size="large" className="btn-large-primary">
    Search
  </Button>
);

const ApiSearch = () => {
  return (
    <Layout id="ApiSearchCss" css={ApiSearchCss}>
      <Header className="apisearch">
        <Row justify="center" gutter={[20, 20]}>
          <Col span={24}>
            <Typography.Title className="search_header search_content">
              Anthem&rsquo;s Partner APIs
            </Typography.Title>
          </Col>
          <Col span={24} md={16}>
            <Typography.Paragraph className="search_content search_content_para">
            Our APIs are crafted to help brokers, benefit administrators, Insurtech innovators, and others connect directly with Anthem. They simplify daily tasks and ensure sharing information with Anthem is quick, smooth, and accurate.
            </Typography.Paragraph>
          </Col>
          {/* <Col span={14} css={SearchBarCss}>
            <Search
              placeholder="&nbsp;&nbsp;Enter keyword search"
              allowClear
              enterButton={searchButton}
              size="large"
              prefix={prefix}
            />
          </Col> */}
        </Row>
      </Header>
    </Layout>
  );
};

export default ApiSearch;
